<div class="hmf-display-flex">
	<button id="shipping-button"
			class="shipping-button hmf-display-flex hmf-my-xxxs hmf-p-xs hmf-align-items-center hmf-subheader-bold-m"
			[ngClass]="{ 'selected' : selected()}"
			[disabled]="(showCount() && count() === 0) || disabled()"
			(click)="emitSelectedOption()">
		<div class="label-container">
			<p class="label hmf-subheader-bold-m hmf-mb-0">
				{{shippingOption()?.label}}&nbsp;
				@if(showCount()) {
					<span class="hmf-subheader-m"> {{ count() }} </span>
				}
			</p>
		</div>
	</button>
</div>
